var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashbaordNoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.638184,
    width: 40.5932,
    height: 40.5932,
    rx: 20.2966,
    fill: "#F7F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2159 20.9343V18.6791C26.2159 15.4097 23.5655 12.7593 20.2961 12.7593C17.0267 12.7593 14.3763 15.4097 14.3763 18.6791V20.9343L12.1211 25.7265H28.4711L26.2159 20.9343Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9141 26.2905C16.9141 26.2905 16.9141 29.1095 20.2968 29.1095C23.6796 29.1095 23.6796 26.2905 23.6796 26.2905",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbaordNoti);
export default __webpack_public_path__ + "static/media/dashbaordNoti.80f69f8e.svg";
export { ForwardRef as ReactComponent };